import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const getServiceSelection = async ({ queryKey }: JsonDataItem) => {
  const owProductId = queryKey[1]?.product_id;
  const productParam = owProductId ? `?product_id[]=${owProductId}` : '';
  const { data } = await baseQuery(`service-selection${productParam}`);

  return data;
};
